module.exports = __webpack_public_path__ + "img/Group 73.250edd26.svg";